"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MS_PER_YEAR = exports.ACCOUNT_NOT_SET_ERROR_MESSAGE = exports.IGNORED_ERROR_MESSAGES = exports.PERMILL_BASE = exports.FIXEDI128_SCALING_FACTOR = exports.PERCENTAGE_GRANULARITY = void 0;
const big_js_1 = __importDefault(require("big.js"));
exports.PERCENTAGE_GRANULARITY = 3;
exports.FIXEDI128_SCALING_FACTOR = 18;
exports.PERMILL_BASE = 1000000;
// IssueCompleted errors occur due to the vault having
// already auto-executed the issuance
exports.IGNORED_ERROR_MESSAGES = ["issue.IssueCompleted"];
exports.ACCOUNT_NOT_SET_ERROR_MESSAGE = "cannot sign transaction without setting account";
exports.MS_PER_YEAR = big_js_1.default(86400 * 365 * 1000);
//# sourceMappingURL=constants.js.map